/**
 * Business Resources
 * @version 1.0.0
 * @author Erik Ondrus <erik.ondrus@avast.com>
 * @requires avast.cash
 */

// todo:
// fulltext search
// url parameters

(function() {
	'use strict';

	var $ = avm.require('cash');

	var $resource = $('.js-resource'),
		$filterType = $('#filterType'),
		$filterTag = $('#filterTag'),
		$filterFulltext = $('#filterFulltext'),
		$showMore = $('.js-show-more-resources .btn'),
		$emptyElement = $('.js-resource-empty');


	var types = new Set(),
		tags = new Set(),
		filterTypeValue = 'all',
		filterTagValue = 'all',
		filterFulltextValue = '';

	$resource.each(function() {
		types.add($(this).attr('data-type'));
		tags.add($(this).attr('data-tag'));
	});

	types.forEach(function(value) {
		$filterType.append(new Option(value, value));
	});

	tags.forEach(function(value) {
		$filterTag.append(new Option(value, value));
	});

	$filterType.on('change', function() {
		filterTypeValue = $(this).val();
		filterResources();
	});

	$filterTag.on('change', function() {
		filterTagValue = $(this).val();
		filterResources();
	});

	$filterFulltext.on('keyup', function() {
		filterFulltextValue = $(this).val();
		filterResources();
	});

	$showMore.on('click', function() {
		filterResources();
		$(this).addClass('d-none');
	});

	function filterResources() {
		var visibleElements = 0;
		$resource.each(function() {
			var type = $(this).data('type');
			var tag = $(this).data('tag');

			var foundInFulltext = 
				$(this).find('.card-title').text().toLowerCase().indexOf(filterFulltextValue.toLowerCase()) > -1 
				|| 
				$(this).find('.card-text').text().toLowerCase().indexOf(filterFulltextValue.toLowerCase()) > -1;

			if ((filterTypeValue === 'all' || type === filterTypeValue) && (filterTagValue === 'all' || tag === filterTagValue) && (filterFulltextValue == '' || foundInFulltext)) {
				visibleElements++;
				$(this).removeClass('d-none');
				return;
			}

			$(this).addClass('d-none');
		});

		$showMore.addClass('d-none');
		visibleElements === 0 ? $emptyElement.removeClass('d-none') : $emptyElement.addClass('d-none');		
	}
})();
